/*
 * Custom Shopify Markets country selector
 * Markup: snippets/custom-country-modal.liquid
 * Triggers: [data-country-open] in snippets/header-icons.liquid and snippets/drawer-menu.liquid
 */
(function() {
  'use strict';

  var STORAGE_KEY = 'alizeh_selected_country_v1';
  var DETECTED_KEY = 'alizeh_detected_country_v1';
  var DISMISSED_KEY = 'alizeh-country-dismissed-v1';
  var DOUBLY_REQUEST_KEY = 'alizeh-doubly-request-v1';
  var DOUBLY_ATTEMPT_KEY = 'alizeh-doubly-attempt-v1';
  var DOUBLY_OFF_KEY = 'alizeh-doubly-sync-off';
  var PREFERENCE_VERSION = 1;
  var DETECT_TIMEOUT = 3000;
  var DOUBLY_TIMEOUT = 10000;
  var DOUBLY_SETTLE = 600;
  var DOUBLY_TRIES = 3;
  // theme.Drawers animates out in 0.25s and returns focus to its opener after 500ms
  var DRAWER_CLOSE_DELAY = 550;
  var MODAL_TRANSITION = 200;
  var OPEN_CLASS = 'custom-country-open';
  var VISIBLE_CLASS = 'is-open';

  var state = {
    isOpen: false,
    pendingOpen: false,
    submitting: false,
    trigger: null,
    returnFocus: null,
    hideTimer: null,
    detectedCode: null,
    detectionReady: false,
    detectionPromise: null,
    userInteracted: false,
    awaitingDetection: false
  };

  /*============================================================================
    Storage (may be blocked, every call is guarded)
  ==============================================================================*/
  function getStore(type) {
    try {
      return window[type] || null;
    } catch (e) {
      return null;
    }
  }

  function storageGet(type, key) {
    var store = getStore(type);
    if (!store) return null;
    try {
      return store.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function storageSet(type, key, value) {
    var store = getStore(type);
    if (!store) return false;
    try {
      store.setItem(key, value);
      return store.getItem(key) === value;
    } catch (e) {
      return false;
    }
  }

  function storageRemove(type, key) {
    var store = getStore(type);
    if (!store) return;
    try {
      store.removeItem(key);
    } catch (e) {}
  }

  /*============================================================================
    Helpers
  ==============================================================================*/
  function toArray(list) {
    return Array.prototype.slice.call(list);
  }

  function getModal() {
    return document.querySelector('[data-country-modal]');
  }

  function find(modal, selector) {
    return modal.querySelector(selector);
  }

  function getOptions(modal) {
    return toArray(modal.querySelectorAll('[data-country-option]'));
  }

  function getVisibleOptions(modal) {
    return getOptions(modal).filter(function(option) {
      return !option.parentNode.hidden;
    });
  }

  // Options are rendered from localization.available_countries, so this is the source of truth
  function findOption(modal, code) {
    if (!code) return null;
    code = String(code).toUpperCase();
    var options = getOptions(modal);
    for (var i = 0; i < options.length; i++) {
      if (options[i].getAttribute('data-code') === code) return options[i];
    }
    return null;
  }

  function getCurrentCountry(modal) {
    return (modal.getAttribute('data-current-country') || '').toUpperCase();
  }

  function getTriggers() {
    return toArray(document.querySelectorAll('[data-country-open]'));
  }

  function drawerIsOpen() {
    var html = document.documentElement;
    return html.classList.contains('js-drawer-open') || html.classList.contains('js-drawer-closing');
  }

  // Visible, still in the page, and not inside a closed off-canvas drawer
  function canFocus(el) {
    if (!el || el === document.body || !document.contains(el) || !el.getClientRects().length) return false;
    var drawer = el.closest('.drawer');
    return !drawer || drawer.classList.contains('drawer--is-open');
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /*============================================================================
    Saved preference
  ==============================================================================*/
  function readPreference(modal) {
    var raw = storageGet('localStorage', STORAGE_KEY);
    if (!raw) return null;

    var data = null;
    try {
      data = JSON.parse(raw);
    } catch (e) {}

    var code = data && typeof data.countryCode === 'string' ? data.countryCode.toUpperCase() : '';
    if (!data || data.version !== PREFERENCE_VERSION || data.confirmed !== true || !findOption(modal, code)) {
      storageRemove('localStorage', STORAGE_KEY);
      return null;
    }

    return code;
  }

  function savePreference(code) {
    storageSet('localStorage', STORAGE_KEY, JSON.stringify({
      countryCode: code,
      confirmed: true,
      version: PREFERENCE_VERSION
    }));
  }

  /*============================================================================
    Picker
  ==============================================================================*/
  function cloneFlag(option) {
    var flag = option.querySelector('.custom-country__flag');
    if (!flag) return null;
    var clone = flag.cloneNode(true);
    clone.removeAttribute('loading');
    return clone;
  }

  function selectOption(modal, option) {
    find(modal, '[data-country-code]').value = option.getAttribute('data-code');

    getOptions(modal).forEach(function(opt) {
      opt.setAttribute('aria-selected', opt === option ? 'true' : 'false');
    });

    var flagHolder = find(modal, '[data-country-field-flag]');
    var flag = cloneFlag(option);
    if (flagHolder && flag) {
      flagHolder.innerHTML = '';
      flagHolder.appendChild(flag);
    }

    find(modal, '[data-country-field-name]').textContent = option.getAttribute('data-name');
  }

  // Keep the header and drawer labels aligned with the visitor's confirmed choice.
  function updateTriggerLabels(modal, code) {
    var option = findOption(modal, code);
    if (!option) return;

    getTriggers().forEach(function(trigger) {
      var oldFlag = trigger.querySelector('.custom-country__flag');
      var newFlag = cloneFlag(option);
      if (oldFlag && newFlag) oldFlag.parentNode.replaceChild(newFlag, oldFlag);

      var name = trigger.querySelector('.custom-country__trigger-name');
      if (name) name.textContent = option.getAttribute('data-name');
    });
  }

  function resetDialog(modal) {
    var title = find(modal, '[data-country-title]');
    if (title) title.textContent = modal.getAttribute('data-title-default');

    var option = findOption(modal, state.detectedCode) || findOption(modal, getCurrentCountry(modal));
    if (option) selectOption(modal, option);
    if (state.detectedCode && option && option.getAttribute('data-code') === state.detectedCode) {
      setDetectedTitle(modal, option.getAttribute('data-name'));
    }
  }

  function chooseOption(modal, option) {
    state.userInteracted = true;
    selectOption(modal, option);
    closePicker(modal, true);
  }

  function isPickerOpen(modal) {
    var picker = find(modal, '[data-country-picker]');
    return picker && !picker.hidden;
  }

  function openPicker(modal) {
    var search = find(modal, '[data-country-search]');
    var list = find(modal, '[data-country-list]');

    find(modal, '[data-country-picker]').hidden = false;
    find(modal, '[data-country-field]').setAttribute('aria-expanded', 'true');

    search.value = '';
    filterOptions(modal, '');

    // Scroll only the list (scrollIntoView would also move the dialog), centring the selected country
    var selected = find(modal, '[data-country-option][aria-selected="true"]');
    list.scrollTop = selected
      ? selected.offsetTop - (list.clientHeight - selected.offsetHeight) / 2
      : 0;

    search.focus({ preventScroll: true });
  }

  function closePicker(modal, focusField) {
    var field = find(modal, '[data-country-field]');
    find(modal, '[data-country-picker]').hidden = true;
    field.setAttribute('aria-expanded', 'false');
    if (focusField) field.focus();
  }

  function filterOptions(modal, query) {
    var term = query.trim().toLowerCase();
    var visibleCount = 0;

    getOptions(modal).forEach(function(option) {
      var name = (option.getAttribute('data-name') || '').toLowerCase();
      var code = (option.getAttribute('data-code') || '').toLowerCase();
      var match = !term || name.indexOf(term) !== -1 || code.indexOf(term) !== -1;
      option.parentNode.hidden = !match;
      if (match) visibleCount++;
    });

    var empty = find(modal, '[data-country-empty]');
    empty.textContent = visibleCount ? '' : empty.getAttribute('data-empty-text');
  }

  function moveOptionFocus(modal, current, step) {
    var visible = getVisibleOptions(modal);
    if (!visible.length) return;

    var index = visible.indexOf(current);
    var next = index === -1
      ? (step > 0 ? 0 : visible.length - 1)
      : (index + step + visible.length) % visible.length;

    visible[next].focus();
  }

  /*============================================================================
    Modal
  ==============================================================================*/
  function setTriggersExpanded(value) {
    getTriggers().forEach(function(trigger) {
      trigger.setAttribute('aria-expanded', value);
    });
  }

  function openModal(modal, trigger) {
    if (!modal || state.isOpen) return;

    state.userInteracted = false;
    resetDialog(modal);

    clearTimeout(state.hideTimer);
    state.isOpen = true;
    state.trigger = trigger || null;
    state.returnFocus = document.activeElement;

    modal.hidden = false;
    void modal.offsetWidth; // reflow so the reveal transition runs
    modal.classList.add(VISIBLE_CLASS);
    document.documentElement.classList.add(OPEN_CLASS);
    setTriggersExpanded('true');

    find(modal, '.custom-country__dialog').focus();
    startDetection(modal);
  }

  function closeModal(modal, options) {
    if (!modal || !state.isOpen) return;
    options = options || {};

    state.isOpen = false;
    closePicker(modal, false);
    modal.classList.remove(VISIBLE_CLASS);
    document.documentElement.classList.remove(OPEN_CLASS);
    setTriggersExpanded('false');

    if (options.dismiss) {
      storageSet('sessionStorage', DISMISSED_KEY, '1');
    }

    clearTimeout(state.hideTimer);
    state.hideTimer = setTimeout(function() {
      modal.hidden = true;
    }, prefersReducedMotion() ? 0 : MODAL_TRANSITION);

    restoreFocus();
  }

  function restoreFocus() {
    var candidates = [state.trigger || state.returnFocus]
      .concat(getTriggers())
      .concat(toArray(document.querySelectorAll('.js-drawer-open-nav')));

    state.trigger = null;
    state.returnFocus = null;

    for (var i = 0; i < candidates.length; i++) {
      if (canFocus(candidates[i])) {
        candidates[i].focus();
        return;
      }
    }
  }

  // Theme drawers return focus to their opener 500ms after closing, so wait them out
  function requestOpen(trigger) {
    if (state.isOpen || state.pendingOpen || state.submitting) return;

    if (!drawerIsOpen()) {
      openModal(getModal(), trigger);
      return;
    }

    state.pendingOpen = true;
    if (trigger.closest('#NavDrawer') && window.theme && theme.NavDrawer && theme.NavDrawer.isOpen) {
      theme.NavDrawer.close();
    }

    setTimeout(function() {
      state.pendingOpen = false;
      openModal(getModal(), trigger);
    }, DRAWER_CLOSE_DELAY);
  }

  function trapFocus(modal, evt) {
    var dialog = find(modal, '.custom-country__dialog');
    var focusable = toArray(dialog.querySelectorAll('button, input:not([type="hidden"]), [href], [tabindex]'))
      .filter(function(el) {
        return !el.disabled && el.getAttribute('tabindex') !== '-1' && el.getClientRects().length;
      });
    if (!focusable.length) return;

    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    var active = document.activeElement;

    if (!dialog.contains(active)) {
      evt.preventDefault();
      first.focus();
    } else if (evt.shiftKey && (active === first || active === dialog)) {
      evt.preventDefault();
      last.focus();
    } else if (!evt.shiftKey && active === last) {
      evt.preventDefault();
      first.focus();
    }
  }

  /*============================================================================
    Market sync and detection
  ==============================================================================*/
  function detectCountry() {
    if (!window.fetch || !window.Promise) return Promise.resolve(null);

    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timer;

    var timeout = new Promise(function(resolve) {
      timer = setTimeout(function() {
        if (controller) controller.abort();
        resolve(null);
      }, DETECT_TIMEOUT);
    });

    var request = fetch('/browsing_context_suggestions.json?country[enabled]=true&currency[enabled]=true', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      signal: controller ? controller.signal : undefined
    })
      .then(function(response) {
        return response.ok ? response.json() : null;
      })
      .then(function(data) {
        var country = data && data.detected_values && data.detected_values.country;
        return country && country.handle ? String(country.handle).toUpperCase() : null;
      })
      .catch(function() {
        return null;
      });

    return Promise.race([request, timeout]).then(function(code) {
      clearTimeout(timer);
      return code;
    });
  }

  function startDetection(modal) {
    if (state.detectionPromise) return state.detectionPromise;

    var cached = storageGet('sessionStorage', DETECTED_KEY);
    state.detectionPromise = cached !== null ? Promise.resolve(cached || null) : detectCountry();
    state.detectionPromise = state.detectionPromise.then(function(code) {
      if (cached === null) storageSet('sessionStorage', DETECTED_KEY, code || '');
      var option = findOption(modal, code);
      state.detectedCode = option ? option.getAttribute('data-code') : null;
      state.detectionReady = true;

      if (state.isOpen && getModal() === modal) {
        var title = find(modal, '[data-country-title]');
        if (title) title.textContent = modal.getAttribute('data-title-default');
        if (option) {
          setDetectedTitle(modal, option.getAttribute('data-name'));
          if (!state.userInteracted) selectOption(modal, option);
        }
      }
      return state.detectedCode;
    });
    return state.detectionPromise;
  }

  /*============================================================================
    Doubly currency converter sync
    Doubly converts prices in the browser, so its currency has to follow the
    market country after the localization form reloads the page. Only Doubly's
    own click path is used (open its dropdown, click the option); its select
    is only read, and none of its storage keys or cookies are touched.
  ==============================================================================*/
  // ISO 3166-1 alpha-2 -> ISO 4217, from country-to-currency 3.0.1 (MIT).
  // HR, LV and LT are EUR (Doubly still lists the obsolete HRK, LVL and LTL).
  var COUNTRY_CURRENCY = {
    AC: 'SHP', AD: 'EUR', AE: 'AED', AF: 'AFN', AG: 'XCD', AI: 'XCD', AL: 'ALL', AM: 'AMD',
    AN: 'ANG', AO: 'AOA', AQ: 'USD', AR: 'ARS', AS: 'USD', AT: 'EUR', AU: 'AUD', AW: 'AWG',
    AX: 'EUR', AZ: 'AZN', BA: 'BAM', BB: 'BBD', BD: 'BDT', BE: 'EUR', BF: 'XOF', BG: 'EUR',
    BH: 'BHD', BI: 'BIF', BJ: 'XOF', BL: 'EUR', BM: 'BMD', BN: 'BND', BO: 'BOB', BQ: 'USD',
    BR: 'BRL', BS: 'BSD', BT: 'BTN', BV: 'NOK', BW: 'BWP', BY: 'BYN', BZ: 'BZD', CA: 'CAD',
    CC: 'AUD', CD: 'CDF', CF: 'XAF', CG: 'XAF', CH: 'CHF', CI: 'XOF', CK: 'NZD', CL: 'CLP',
    CM: 'XAF', CN: 'CNY', CO: 'COP', CR: 'CRC', CU: 'CUP', CV: 'CVE', CW: 'XCG', CX: 'AUD',
    CY: 'EUR', CZ: 'CZK', DE: 'EUR', DJ: 'DJF', DK: 'DKK', DM: 'XCD', DO: 'DOP', DZ: 'DZD',
    EC: 'USD', EE: 'EUR', EG: 'EGP', EH: 'MAD', ER: 'ERN', ES: 'EUR', ET: 'ETB', FI: 'EUR',
    FJ: 'FJD', FK: 'FKP', FM: 'USD', FO: 'DKK', FR: 'EUR', GA: 'XAF', GB: 'GBP', GD: 'XCD',
    GE: 'GEL', GF: 'EUR', GG: 'GBP', GH: 'GHS', GI: 'GIP', GL: 'DKK', GM: 'GMD', GN: 'GNF',
    GP: 'EUR', GQ: 'XAF', GR: 'EUR', GS: 'FKP', GT: 'GTQ', GU: 'USD', GW: 'XOF', GY: 'GYD',
    HK: 'HKD', HM: 'AUD', HN: 'HNL', HR: 'EUR', HT: 'HTG', HU: 'HUF', ID: 'IDR', IE: 'EUR',
    IL: 'ILS', IM: 'GBP', IN: 'INR', IO: 'USD', IQ: 'IQD', IR: 'IRR', IS: 'ISK', IT: 'EUR',
    JE: 'GBP', JM: 'JMD', JO: 'JOD', JP: 'JPY', KE: 'KES', KG: 'KGS', KH: 'KHR', KI: 'AUD',
    KM: 'KMF', KN: 'XCD', KP: 'KPW', KR: 'KRW', KW: 'KWD', KY: 'KYD', KZ: 'KZT', LA: 'LAK',
    LB: 'LBP', LC: 'XCD', LI: 'CHF', LK: 'LKR', LR: 'LRD', LS: 'LSL', LT: 'EUR', LU: 'EUR',
    LV: 'EUR', LY: 'LYD', MA: 'MAD', MC: 'EUR', MD: 'MDL', ME: 'EUR', MF: 'EUR', MG: 'MGA',
    MH: 'USD', MK: 'MKD', ML: 'XOF', MM: 'MMK', MN: 'MNT', MO: 'MOP', MP: 'USD', MQ: 'EUR',
    MR: 'MRU', MS: 'XCD', MT: 'EUR', MU: 'MUR', MV: 'MVR', MW: 'MWK', MX: 'MXN', MY: 'MYR',
    MZ: 'MZN', NA: 'NAD', NC: 'XPF', NE: 'XOF', NF: 'AUD', NG: 'NGN', NI: 'NIO', NL: 'EUR',
    NO: 'NOK', NP: 'NPR', NR: 'AUD', NU: 'NZD', NZ: 'NZD', OM: 'OMR', PA: 'PAB', PE: 'PEN',
    PF: 'XPF', PG: 'PGK', PH: 'PHP', PK: 'PKR', PL: 'PLN', PM: 'EUR', PN: 'NZD', PR: 'USD',
    PS: 'ILS', PT: 'EUR', PW: 'USD', PY: 'PYG', QA: 'QAR', RE: 'EUR', RO: 'RON', RS: 'RSD',
    RU: 'RUB', RW: 'RWF', SA: 'SAR', SB: 'SBD', SC: 'SCR', SD: 'SDG', SE: 'SEK', SG: 'SGD',
    SH: 'SHP', SI: 'EUR', SJ: 'NOK', SK: 'EUR', SL: 'SLE', SM: 'EUR', SN: 'XOF', SO: 'SOS',
    SR: 'SRD', SS: 'SSP', ST: 'STN', SV: 'USD', SX: 'XCG', SY: 'SYP', SZ: 'SZL', TA: 'GBP',
    TC: 'USD', TD: 'XAF', TF: 'EUR', TG: 'XOF', TH: 'THB', TJ: 'TJS', TK: 'NZD', TL: 'USD',
    TM: 'TMT', TN: 'TND', TO: 'TOP', TR: 'TRY', TT: 'TTD', TV: 'AUD', TW: 'TWD', TZ: 'TZS',
    UA: 'UAH', UG: 'UGX', UM: 'USD', US: 'USD', UY: 'UYU', UZ: 'UZS', VA: 'EUR', VC: 'XCD',
    VE: 'VES', VG: 'USD', VI: 'USD', VN: 'VND', VU: 'VUV', WF: 'XPF', WS: 'WST', XK: 'EUR',
    YE: 'YER', YT: 'EUR', ZA: 'ZAR', ZM: 'ZMW', ZW: 'ZWG'
  };

  function getDoublyWidget() {
    var widgets = toArray(document.querySelectorAll('.doubly-nice-select'));
    for (var i = 0; i < widgets.length; i++) {
      if (widgets[i].querySelector('li.option[data-value]')) return widgets[i];
    }
    return null;
  }

  // Doubly renders its widget after page load and finishes setting it up after
  // that. Clicking too early can hit a half-initialised Doubly, so wait for the
  // widget, the window load event, and DOUBLY_SETTLE ms without changes inside
  // the widget, the way a visitor's click always comes later. With afterChange,
  // the widget must change at least once first (used before a retry).
  // MutationObservers only, no polling; resolves null after `timeout` ms.
  function waitForDoubly(timeout, afterChange) {
    return new Promise(function(resolve) {
      if (!window.MutationObserver || timeout <= 0) {
        resolve(null);
        return;
      }

      var widget = null;
      var loaded = document.readyState === 'complete';
      var changed = !afterChange;
      var quietTimer;
      var giveUpTimer;

      var widgetObserver = new MutationObserver(function() {
        changed = true;
        restartQuiet();
      });
      var pageObserver = new MutationObserver(function() {
        attach(getDoublyWidget());
      });

      function attach(found) {
        if (!found || widget) return;
        widget = found;
        pageObserver.disconnect();
        widgetObserver.observe(widget, { childList: true, subtree: true, attributes: true, characterData: true });
        restartQuiet();
      }

      function restartQuiet() {
        clearTimeout(quietTimer);
        if (!widget || !loaded || !changed) return;
        quietTimer = setTimeout(function() {
          // Doubly may have re-rendered the widget while settling
          finish(document.contains(widget) ? widget : getDoublyWidget());
        }, DOUBLY_SETTLE);
      }

      function onLoad() {
        loaded = true;
        restartQuiet();
      }

      function finish(result) {
        pageObserver.disconnect();
        widgetObserver.disconnect();
        clearTimeout(quietTimer);
        clearTimeout(giveUpTimer);
        window.removeEventListener('load', onLoad);
        resolve(result);
      }

      giveUpTimer = setTimeout(function() {
        finish(null);
      }, timeout);

      window.addEventListener('load', onLoad);
      pageObserver.observe(document.documentElement, { childList: true, subtree: true });
      attach(getDoublyWidget());
    });
  }

  function getDoublySelect(widget) {
    var prev = widget.previousElementSibling;
    if (prev && prev.matches('select[name="doubly-currencies"]')) return prev;
    return document.querySelector('select[name="doubly-currencies"]');
  }

  function getDoublyCurrencies(widget) {
    return toArray(widget.querySelectorAll('li.option[data-value]')).map(function(option) {
      return option.getAttribute('data-value');
    });
  }

  // The currency Doubly currently shows
  function getDoublyCurrent(widget) {
    var selected = widget.querySelector('li.option.selected[data-value]');
    if (selected) return selected.getAttribute('data-value');
    var select = getDoublySelect(widget);
    return select ? select.value : null;
  }

  function pickCurrency(country, available) {
    var candidates = [COUNTRY_CURRENCY[country], country === 'PK' ? 'PKR' : 'USD'];
    for (var i = 0; i < candidates.length; i++) {
      if (candidates[i] && available.indexOf(candidates[i]) !== -1) return candidates[i];
    }
    return null;
  }

  // Exactly what a visitor does: click Doubly's dropdown open, then click the
  // option. nice-select closes itself again. Nothing else is written: no select
  // value, no classes, no price elements.
  function setDoublyCurrency(widget, currency) {
    var option = widget.querySelector('li.option[data-value="' + currency + '"]');
    if (!option) return;
    widget.click();
    option.click();
  }

  // QA switch for comparing against Doubly's own behaviour:
  // ?doubly_sync=off disables the sync for this tab session, ?doubly_sync=on re-enables it
  function doublySyncDisabled() {
    var param = null;
    try {
      param = new URLSearchParams(window.location.search).get('doubly_sync');
    } catch (e) {}

    if (param === 'off') storageSet('sessionStorage', DOUBLY_OFF_KEY, '1');
    if (param === 'on') storageRemove('sessionStorage', DOUBLY_OFF_KEY);
    return param === 'off' || storageGet('sessionStorage', DOUBLY_OFF_KEY) === '1';
  }

  // Switch Doubly when our selector changed the market (request flag) or when
  // Doubly's currency doesn't match the market country. One attempt per
  // country/currency is recorded so a Doubly reload can never loop.
  function syncDoubly(modal) {
    if (doublySyncDisabled()) return;

    var country = getCurrentCountry(modal);
    var requested = storageGet('sessionStorage', DOUBLY_REQUEST_KEY) === country;
    storageRemove('sessionStorage', DOUBLY_REQUEST_KEY);

    var deadline = Date.now() + DOUBLY_TIMEOUT;

    function tryClick(triesLeft, isRetry) {
      waitForDoubly(deadline - Date.now(), isRetry).then(function(widget) {
        if (!widget) return;

        var target = pickCurrency(country, getDoublyCurrencies(widget));
        if (!target) return;

        var attempt = country + ':' + target;
        if (getDoublyCurrent(widget) === target) {
          storageRemove('sessionStorage', DOUBLY_ATTEMPT_KEY);
          return;
        }

        if (!isRetry) {
          if (!requested && storageGet('sessionStorage', DOUBLY_ATTEMPT_KEY) === attempt) return;
          if (!storageSet('sessionStorage', DOUBLY_ATTEMPT_KEY, attempt)) return;
        }

        setDoublyCurrency(widget, target);

        // Doubly not ready for the click yet: try the same click again once its widget changes
        if (getDoublyCurrent(widget) !== target && triesLeft > 1) {
          tryClick(triesLeft - 1, true);
        }
      });
    }

    tryClick(DOUBLY_TRIES, false);
  }

  function setDetectedTitle(modal, countryName) {
    var template = modal.getAttribute('data-title-detected');
    var title = find(modal, '[data-country-title]');
    if (template && title) {
      title.textContent = template.replace('[country]', countryName);
    }
  }

  function init() {
    var modal = getModal();
    if (!modal) return;

    setTriggersExpanded('false');

    var saved = readPreference(modal);
    if (saved) updateTriggerLabels(modal, saved);

    // No automatic popup or redirect inside the theme editor
    if (window.Shopify && Shopify.designMode) return;

    syncDoubly(modal);

    if (storageGet('sessionStorage', DISMISSED_KEY)) return;
    if (!drawerIsOpen()) openModal(modal, null);
  }

  /*============================================================================
    Events (delegated)
  ==============================================================================*/
  function onClick(evt) {
    var target = evt.target;
    if (!target || !target.closest) return;

    var trigger = target.closest('[data-country-open]');
    if (trigger) {
      evt.preventDefault();
      requestOpen(trigger);
      return;
    }

    var modal = getModal();
    if (!modal || !state.isOpen || !modal.contains(target)) return;

    if (target.closest('[data-country-close]')) {
      closeModal(modal, { dismiss: true });
      return;
    }

    if (target.closest('[data-country-field]')) {
      state.userInteracted = true;
      if (isPickerOpen(modal)) {
        closePicker(modal, true);
      } else {
        openPicker(modal);
      }
      return;
    }

    var option = target.closest('[data-country-option]');
    if (option) {
      chooseOption(modal, option);
      return;
    }

    if (isPickerOpen(modal) && !target.closest('[data-country-picker]')) {
      closePicker(modal, false);
    }
  }

  function onInput(evt) {
    var target = evt.target;
    if (!target.matches || !target.matches('[data-country-search]')) return;

    var modal = target.closest('[data-country-modal]');
    if (modal) {
      state.userInteracted = true;
      filterOptions(modal, target.value);
    }
  }

  function onKeydown(evt) {
    if (!state.isOpen) return;

    var modal = getModal();
    if (!modal) return;

    var target = evt.target;

    if (evt.key === 'Escape' || evt.key === 'Esc') {
      evt.preventDefault();
      if (isPickerOpen(modal)) {
        closePicker(modal, true);
      } else {
        closeModal(modal, { dismiss: true });
      }
      return;
    }

    if (evt.key === 'Tab') {
      trapFocus(modal, evt);
      return;
    }

    if (!target.closest || !target.closest('[data-country-picker]')) return;

    var option = target.closest('[data-country-option]');

    if (evt.key === 'ArrowDown' || evt.key === 'ArrowUp') {
      evt.preventDefault();
      moveOptionFocus(modal, option, evt.key === 'ArrowDown' ? 1 : -1);
    } else if (evt.key === 'Enter') {
      // Also stops Enter in the search field from submitting the form
      evt.preventDefault();
      if (!option && target.matches('[data-country-search]')) {
        option = getVisibleOptions(modal)[0];
      }
      if (option) chooseOption(modal, option);
    }
  }

  function onSubmit(evt) {
    var form = evt.target;
    if (!form.matches || !form.matches('[data-country-form]')) return;

    var modal = form.closest('[data-country-modal]');
    if (!modal) return;

    if (state.submitting || state.awaitingDetection) {
      evt.preventDefault();
      return;
    }

    if (!state.userInteracted && !state.detectionReady) {
      evt.preventDefault();
      state.awaitingDetection = true;
      var waitingButton = find(modal, '[data-country-confirm]');
      waitingButton.disabled = true;
      waitingButton.setAttribute('aria-busy', 'true');
      startDetection(modal).then(function() {
        state.awaitingDetection = false;
        waitingButton.disabled = false;
        waitingButton.removeAttribute('aria-busy');
        if (state.isOpen && getModal() === modal) form.requestSubmit(waitingButton);
      });
      return;
    }

    var input = find(modal, '[data-country-code]');
    var code = (input.value || '').toUpperCase();

    if (!findOption(modal, code)) {
      evt.preventDefault();
      openPicker(modal);
      return;
    }

    input.value = code;
    savePreference(code);
    updateTriggerLabels(modal, code);
    storageSet('sessionStorage', DISMISSED_KEY, '1');

    if (code === getCurrentCountry(modal)) {
      evt.preventDefault();
      closeModal(modal, { dismiss: true });
      syncDoubly(modal);
      return;
    }

    storageSet('sessionStorage', DOUBLY_REQUEST_KEY, code);
    state.submitting = true;

    var button = find(modal, '[data-country-confirm]');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
  }

  function resetSubmitting() {
    state.submitting = false;
    var modal = getModal();
    var button = modal && find(modal, '[data-country-confirm]');
    if (button) {
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }

  document.addEventListener('click', onClick);
  document.addEventListener('input', onInput);
  document.addEventListener('keydown', onKeydown);
  document.addEventListener('submit', onSubmit);

  document.addEventListener('shopify:section:unload', function(evt) {
    if (evt.target && evt.target.querySelector && !evt.target.querySelector('[data-country-modal]')) return;
    document.documentElement.classList.remove(OPEN_CLASS);
    clearTimeout(state.hideTimer);
    state.isOpen = false;
    state.pendingOpen = false;
    state.trigger = null;
    state.returnFocus = null;
  });

  // Restored from the back/forward cache after a submit: start closed again
  window.addEventListener('pageshow', function(evt) {
    if (!evt.persisted) return;
    resetSubmitting();
    var modal = getModal();
    if (modal && state.isOpen) closeModal(modal, { dismiss: false });
    setTriggersExpanded('false');
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
